import React, { useEffect, useMemo, useState } from 'react';
import { Stack, StackProps, Typography } from '@mui/material';
import { CashRegister } from '@api/CashRegister/CashRegister';
import { format } from 'date-fns';
import UserService from '@api/Users/UserCtrl';
import { showAlertError } from '@utils/Alerts/Error';
import { UserType } from '@api/Users/User';
import { toDateSafe } from '@utils/Date';

interface CashRegisterInfoProps extends StackProps {
    cashRegister: CashRegister;
}

const CashRegisterInfo: React.FunctionComponent<CashRegisterInfoProps> = (props) => {
    const { cashRegister } = props;
    const userService = useMemo(() => new UserService(), []);
    const [user, setUser] = useState<UserType | undefined>(undefined);

    // ⚠️ Esto usaba `parseFirebaseDate`, que devolvía `Invalid Date` para un
    // Timestamp con `nanoseconds: 0` — y `format()` de date-fns **lanza
    // RangeError** con una fecha inválida, así que el modal entero se caía por
    // una fecha. Ahora la falta de dato se ve como falta de dato.
    const fechaDeApertura = useMemo(() => {
        const fecha = toDateSafe(cashRegister.date);
        return fecha ? format(fecha, 'dd-MM-yyy') : 'Sin fecha';
    }, [cashRegister.date]);

    const getData = async () => {
        try {
            const userData = await userService.getUser(cashRegister.userId);
            setUser(userData);
        } catch (error) {
            showAlertError(error);
        }
    };

    useEffect(() => {
        void getData();
    }, []);

    return (
        <Stack spacing={1}>
            <Stack direction="row" spacing={1}>
                <Typography>Id de caja:</Typography>
                <Typography fontWeight={600}>{cashRegister.id}</Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
                <Typography>Caja abierta el:</Typography>
                <Typography fontWeight={600}>{fechaDeApertura}</Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
                <Typography>Caja abierta por:</Typography>
                <Typography fontWeight={600}>{user?.profile.name}</Typography>
            </Stack>
        </Stack>
    );
};

export default CashRegisterInfo;
